import React from "react";

const WHATSAPP_URL =
  "https://api.whatsapp.com/message/NWVD2NCMR723P1?autoload=1&app_absent=0";

export const WhatsAppFab = () => {
  return (
    <a
      href={WHATSAPP_URL}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-fab"
      aria-label="Chat on WhatsApp"
      className="group fixed z-[60] bottom-5 left-5 sm:bottom-6 sm:left-6 inline-flex items-center gap-2 rounded-full bg-[#25D366] hover:bg-[#1ebe57] text-white shadow-[0_10px_30px_rgba(37,211,102,0.45)] hover:-translate-y-0.5 transition-all px-4 py-3 sm:px-5 sm:py-3.5"
    >
      <span className="grid place-items-center w-6 h-6">
        <svg viewBox="0 0 32 32" className="w-6 h-6" fill="currentColor" aria-hidden="true">
          <path d="M19.11 17.205c-.372 0-1.088 1.39-1.518 1.39-.082 0-.166-.024-.245-.06-.93-.422-1.776-.94-2.481-1.66-.198-.205-.554-.527-.554-.838 0-.296.396-.624.633-.832.198-.176.392-.391.392-.66 0-.293-1.105-2.78-1.337-2.972-.144-.116-.354-.116-.527-.116-.146 0-.305-.012-.451 0-.255.024-.532.05-.755.236-.282.232-.927.985-.927 2.21 0 1.293.97 2.55 1.078 2.682 1.21 1.61 2.404 2.625 4.214 3.297.503.18 2.39.74 2.83.474.402-.243.96-.853 1.117-1.378.07-.232.07-.428.05-.467-.03-.082-.122-.11-.275-.196-.166-.083-.876-.434-1.013-.484-.137-.05-.243-.073-.349.075-.106.148-.398.467-.485.563-.087.094-.174.106-.32.038l-.075-.038z"/>
          <path d="M16 0a16 16 0 0 0-13.84 23.96L0 32l8.27-2.16A16 16 0 1 0 16 0Zm0 29.34c-2.34 0-4.6-.62-6.59-1.79l-.47-.28-4.9 1.28 1.31-4.78-.31-.49a13.34 13.34 0 1 1 10.96 6.06Z"/>
        </svg>
      </span>
      <span className="text-sm font-semibold pr-1 hidden sm:inline">Chat on WhatsApp</span>
    </a>
  );
};

export default WhatsAppFab;
